/** A form's configured translations: English source text mapped to its translation. */
export type FormTranslationMap = Record<string, string>;

/**
 * Resolves an authored English string to its configured translation.
 *
 * Lookup is exact-match on the English source, because that is how the map is keyed — there is no
 * normalization or fuzzy matching. A string with no entry resolves to itself, so a partial map
 * renders a partially translated form rather than blanks.
 *
 * Must run *before* `{{...}}` interpolation: the map is keyed by the authored template
 * (`"Hello {{enduser.fname}}"`), so an already-interpolated string would never match.
 */
export const resolveFormTranslation = (
  value: string | undefined,
  translations: FormTranslationMap | undefined
): string | undefined => {
  if (value === undefined) return undefined;
  return translations?.[value] ?? value;
};
